<template>
  <v-list-item two-line @click="$emit('clicked')">
    <v-list-item-avatar class="mr-3">
      <v-avatar color="primary" size="32">
        <span class="white--text">{{ title[0] }}</span>
      </v-avatar>
    </v-list-item-avatar>
    <v-list-item-content class="pa-0">
      <v-list-item-title>{{ title }}</v-list-item-title>
      <v-list-item-subtitle class="caption">{{ subtitle }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListItemAvatarTwoL',
  props: {
    title: {
      type: String,
      default: 'title'
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>